import { render, staticRenderFns } from "./ItemMediaUploader.vue?vue&type=template&id=bcf3d146&scoped=true&lang=pug&"
import script from "./ItemMediaUploader.vue?vue&type=script&lang=js&"
export * from "./ItemMediaUploader.vue?vue&type=script&lang=js&"
import style0 from "./ItemMediaUploader.vue?vue&type=style&index=0&id=bcf3d146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf3d146",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
